<template>
    <v-container fluid class="px-0 pt-5 px-md-1">


        <div v-if="!previst">
            <v-row>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card class=" mx-1 pt-3 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Turnados
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="end">
                                    <!--<v-avatar
                                              color="grey"
                                      large
                                              icon="mdi-car"
                                    ></v-avatar>-->

                                    <!--<v-list-item-avatar tile
                                                        size="70">
                                        <v-icon color="grey" size="70">
                                            mdi-car-limousine
                                        </v-icon>
                                    </v-list-item-avatar>-->

                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img 
                                               src="https://www.ausa.com.mx/img/colisionN.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Colisiones
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 15px;">
                                        {{dataTurnadoColision.NameMesActualColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 40px; color:#3364FF">
                                        {{dataTurnadoColision.MesActualColision}}
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoColision.MesAnteriorColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px; ">
                                        {{dataTurnadoColision.NameMesAnteriorColision}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoColision.DosMesAnteriorColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoColision.NameDosMesActualColision}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoColision.MesAnteriorAñoAnteriorColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoColision.NameMesAnteriorAñoAnteriorColision}}
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>
                        <v-row><br /><br /></v-row>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoColision.VigenciaActualColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoColision.NameVigenciaActualColision}}
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <!--<v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <center>
                                    <v-row justify="center">
                                        <span style="font-size: 32px; color:#3364FF">
                                            {{dataTurnadoColision.VigenciaAnteriorColision}}
                                        </span>
                                    </v-row>
                                    <v-row justify="center">
                                        <span style="font-size: 15px;  ">
                                            {{dataTurnadoColision.NameVigenciaAnteriorColision}}
                                        </span>
                                    </v-row>
                                </center>
                            </v-col>
                            <v-col cols="2" sm="2">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <center>
                                    <v-row justify="center">
                                        <span style="font-size: 32px; color:#3364FF">
                                            {{dataTurnadoColision.VigenciaActualColision}}
                                        </span>
                                    </v-row>
                                    <v-row justify="center">
                                        <span style="font-size: 15px;  ">
                                            {{dataTurnadoColision.NameVigenciaActualColision}}
                                        </span>
                                    </v-row>
                                </center>
                            </v-col>
                            <v-col cols="1" sm="1">
                            </v-col>
                        </v-row>-->
                        <br />

                    </v-card>

                </v-col>






                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="end">
                                    <!--<v-list-item-avatar tile
                                                        size="70">
                                        <v-icon color="grey" size="70">
                                            mdi-run
                                        </v-icon>
                                    </v-list-item-avatar>-->

                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img 
                                               src="https://www.ausa.com.mx/img/roboN.png"></v-img>
                                    </v-list-item-avatar>

                                    <!--<v-list-item-avatar tile
                                                        width="100"
                                                        height="100"
                                                        color="white">
                                        <v-img height="120"
                                               src="https://www.ausa.com.mx/img/vhrobado1.jpeg"></v-img>
                                    </v-list-item-avatar>-->
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Robos
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameMesActualRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 40px; color:#3364FF">
                                        {{dataTurnadoRobo.MesActualRobo}}
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoRobo.MesAnteriorRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameMesAnteriorRobo}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoRobo.DosMesAnteriorRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameDosMesActualRobo}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoRobo.MesAnteriorAñoAnteriorRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameMesAnteriorAñoAnteriorRobo}}
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>
                        <v-row><br /><br /></v-row>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoRobo.VigenciaActualRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameVigenciaActualRobo}}
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>

                        <!--<v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <center>
                                    <v-row justify="center">
                                        <span style="font-size: 32px; color:#3364FF">
                                            {{dataTurnadoRobo.VigenciaAnteriorRobo}}
                                        </span>
                                    </v-row>
                                    <v-row justify="center">
                                        <span style="font-size: 15px;  ">
                                            {{dataTurnadoRobo.NameVigenciaAnteriorRobo}}
                                        </span>
                                    </v-row>
                                </center>
                            </v-col>
                            <v-col cols="2" sm="2">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <center>
                                    <v-row justify="center">
                                        <span style="font-size: 32px; color:#3364FF">
                                            {{dataTurnadoRobo.VigenciaActualRobo}}
                                        </span>
                                    </v-row>
                                    <v-row justify="center">
                                        <span style="font-size: 15px;  ">
                                            {{dataTurnadoRobo.NameVigenciaActualRobo}}
                                        </span>
                                    </v-row>
                                </center>
                            </v-col>
                            <v-col cols="1" sm="1">
                            </v-col>
                        </v-row>-->


                        <br />

                    </v-card>

                </v-col>
            </v-row>

            <!--2° diapositiva  pendientes-->

            <v-row>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card class=" mx-1 pt-3 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Pendientes
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="end">

                                    <!--<v-list-item-avatar tile
                                                        size="70">
                                        <v-icon color="grey" size="70">
                                            mdi-car-limousine
                                        </v-icon>
                                    </v-list-item-avatar>-->

                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img 
                                               src="https://www.ausa.com.mx/img/colisionN.png"></v-img>
                                    </v-list-item-avatar>

                                    <!--<v-list-item-avatar tile
                                                        size="90"
                                                        color="white">
                                        <v-img height="95"
                                               src="https://www.ausa.com.mx/img/colision.jpg"></v-img>
                                    </v-list-item-avatar>-->
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Colisiones
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3" sm="3">
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayores != 0" class="wrexlink" @click="prevista(1)" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayores}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayores == 0" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayores}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayores != 0" class="wrexlink" @click="prevista(1)" style="font-size: 15px;  ">
                                        Mayores
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayores == 0" style="font-size: 15px;  ">
                                        Mayores
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="2" sm="2">
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenores != 0" class="wrexlink" @click="prevista(2)" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenores}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenores == 0" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenores}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenores != 0" class="wrexlink" @click="prevista(2)" style="font-size: 15px;  ">
                                        Menores
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenores == 0" style="font-size: 15px;  ">
                                        Menores
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>

                        <br />

                    </v-card>

                </v-col>






                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="end">
                                    <!--<v-list-item-avatar tile
                                                        size="70">
                                        <v-icon color="grey" size="70">
                                            mdi-run
                                        </v-icon>
                                    </v-list-item-avatar>-->

                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img
                                               src="https://www.ausa.com.mx/img/roboN.png"></v-img>
                                    </v-list-item-avatar>

                                    <!--<v-list-item-avatar tile
                                                        size="90"
                                                        color="white">
                                        <v-img height="120"
                                               src="https://www.ausa.com.mx/img/vhrobado1.jpeg"></v-img>
                                    </v-list-item-avatar>-->
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Robos
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3" sm="3">
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosDenuncias != 0 && permiso" class="wrexlink" @click="generarTableroRobosDenuncias(5,'Robo','Pendientes-Robos-Solo Denuncias')" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosDenuncias}}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenuncias == 0 || !permiso" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosDenuncias}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosDenuncias != 0 && permiso" class="wrexlink" @click="generarTableroRobosDenuncias(5,'Robo','Pendientes-Robos-Solo Denuncias')" style="font-size: 15px;  ">
                                        Solo Denuncias
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenuncias == 0 || !permiso" style="font-size: 15px;  ">
                                        Solo Denuncias
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosRecuperados != 0" class="wrexlink" @click="prevista(3)" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosRecuperados}}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperados == 0" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosRecuperados}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosRecuperados != 0" class="wrexlink" @click="prevista(3)" style="font-size: 15px;  ">
                                        Recuperados
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperados == 0" style="font-size: 15px;  ">
                                        Recuperados
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>

                        <br />

                    </v-card>

                </v-col>
            </v-row>




            <!--2° diapositiva  VeHículos -->

            <v-row>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card class=" mx-1 pt-3 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Vehículos Detenidos
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="6" sm="6">
                                <v-row justify="end">
                                    <!--<v-list-item-avatar tile
                                                        size="80">
                                        <v-icon color="grey" size="70">
                                            mdi-car
                                        </v-icon>
                                    </v-list-item-avatar>-->
                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="100">
                                        <v-img height="85"
                                               src="https://www.ausa.com.mx/img/carroN.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>

                            </v-col>
                            <v-col cols="2" sm="2">
                                <br />
                                <v-row justify="start">
                                    <span v-if="dataVhDetenidos.VhDetenidos != 0 && permiso" class="wrexlink" @click="generarTableroVHDetenidos(1,'Liberación de Vehículo','Vehículos Detenidos')" style="font-size: 42px; color:#3364FF">
                                        {{dataVhDetenidos.VhDetenidos}}
                                    </span>
                                    <span v-if="dataVhDetenidos.VhDetenidos == 0 || !permiso" style="font-size: 42px; color:#3364FF">
                                        {{dataVhDetenidos.VhDetenidos}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataVhDetenidos.VhDetenidos != 0 && permiso" class="wrexlink" @click="generarTableroVHDetenidos(1,'Liberación de Vehículo','Vehículos Detenidos')" style="font-size: 22px;">
                                        Vehículos Detenidos
                                    </span>
                                    <span v-if="dataVhDetenidos.VhDetenidos == 0 || !permiso" style="font-size: 22px;">
                                        Vehículos Detenidos
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>

                        <br />

                    </v-card>

                </v-col>

            </v-row>
        </div>

        <div v-if="previst">
            <ProcesosViews :tipo="tipo"
                           :dataPendientesColision="dataPendientesColision"
                           :dataPendientesRobo="dataPendientesRobo"
                           @regresardash="regresardash"></ProcesosViews>
        </div>



    </v-container>
</template>



<script>
    import moment from 'moment';
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import ProcesosViews from '@/components/pages/main/Dashboard/ProcesosViews.vue';
    import Inicio from '@/services/main/main.service.js';


    export default {
        components: {
            ProcesosViews
        },
        props: {
            dataTurnadoColision: [],
            dataTurnadoRobo: [],
            dataPendientesColision: [],
            dataPendientesRobo: [],
            dataVhDetenidos: []
        },
        data() {
            return {
                procesos: [],
                proceso: 0,
                nombre: '',
                permiso: false,
                cont: 1,
                previst: false,
                //dataTurnadoColision: [],
                //dataTurnadoRobo: [],
                //dataPendientesColision: [],
                //dataPendientesRobo: [],
                //dataVhDetenidos:[]

            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE']),
            //...mapState("Operacion", ["key"]),
            computedDate() {
                return this.date ? moment(this.date).format('Do MMM YYYY, dddd') : ''
            },
        },
        methods: {
            prevista(tipo) {
                //console.log('Dirige a otra vista');
                this.previst = true;
                this.tipo = tipo;
                this.$emit("cambioCliente", false);
            },
            regresardash() {
                this.$emit("cambioCliente", true);
                this.previst = false;
            },

            generarTableroVHDetenidos(idproceso, PTabNombre,seccion) {
                if (this.cont == 1) {
                    this.cont++;
                    this.$router.push({ name: `tablero`, params: { proceso: idproceso, relevancia: null, aiclave: '1,24', PTabNombre: PTabNombre, seccion: seccion} });
                }
            },
            generarTableroRobosDenuncias(idproceso, PTabNombre, seccion) {
                if (this.cont == 1) {
                    this.cont++;
                    this.$router.push({ name: `tablero`, params: { proceso: idproceso, relevancia: null, aiclave: '24', PTabNombre: PTabNombre, seccion: seccion} });
                }
            },
            //generarTablero(item) {

            //    if (this.cont==1) {
            //        this.proceso = item.ptabclave;
            //        this.nombre = item.ptabnombre;
            //        this.$router.push({ name: `tablero`, params: { proceso: this.proceso, nombre: this.nombre } });
            //    }
            //    this.cont++;

            //},
        },
        async mounted() {
            Inicio.VerificarPermisos(this, 314).then(response => {
                if (response.length > 0) {
                   this.permiso = true;
                }
            });



        }
 }
</script>

<style>
    span.wrexlink {
        cursor: pointer;
    }
</style>
